import { useState } from 'react';
import type { FaqItem } from './faq.types';
import { FaqAccordionItem } from './FaqAccordionItem';

type FaqAccordionProps = {
  items: readonly FaqItem[];
  /** Index of initially open item; `null` = all closed */
  initialOpenIndex?: number | null;
  className?: string;
};

export function FaqAccordion({ items, initialOpenIndex = 0, className }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(
    initialOpenIndex === null ? null : initialOpenIndex,
  );

  const wrapperClass = className ? `flex flex-col ${className}` : 'flex flex-col';

  return (
    <div className={wrapperClass}>
      {items.map((item, i) => (
        <FaqAccordionItem
          key={item.q}
          item={item}
          isOpen={openIndex === i}
          showDivider={i > 0}
          onToggle={() => setOpenIndex(openIndex === i ? null : i)}
        />
      ))}
    </div>
  );
}

